<template>
  <div class="recruit-calendar-panel">
    <div class="calendar-title">
      <div class="calendar-title-left" style="cursor: pointer;">
        企服通道
      </div>
    </div>
    <div class="calendar-main">
      <div class="calendar-left">
        <img src="../assets/images/ic_bg_3.png" alt="" style="width: 80px;height: 80px"/>
        <span class="qy-text">象山“青年与海”<br>人才大厦</span>
        <div class="qy-num"><img src="../assets/images/ic_start.png"
                                 style="width: 15px;height: 15px;padding-right: 5px">一站式地标
        </div>
        <div class="des_span">企业服务、政策兑付、社群交流，青年人才梦想始发港</div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <div class="div_ze" @click.stop="goLink(1)">了解详情 <img src="../assets/images/ic_arrow_right.png"
                                                                    style="width: 16px;height: 10px;"></img>
          </div>
        </div>

      </div>

      <div class="calendar-content">
        <img src="../assets/images/ic_bg_5.png" alt="" style="width: 80px;height: 80px"/>
        <span class="qy-text">企业用工需求<br>调查问卷</span>
        <div class="qy-num"><img src="../assets/images/ic_ing.png" style="width: 15px;height: 15px;padding-right: 5px">进行中
        </div>
        <div class="des_span">动态掌握产业用工需求，切实提高人才招引服务水平</div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <div class="div_ze" @click.stop="goLink(2)">填写问卷
            <img src="../assets/images/ic_arrow_right.png" style="width: 16px;height: 10px;"></img>
          </div>
        </div>


      </div>

      <div class="calendar-right">
        <img src="../assets/images/ic_rg_3.png" alt="" style="width: 80px;height: 80px"/>
        <span class="qy-text">高校毕业生<br>引聚政策</span>
        <div class="qy-num"><img src="../assets/images/ic_gig.png" style="width: 15px;height: 15px;padding-right: 5px">最新升级
        </div>
        <div class="des_span">购房补贴最高35万元，安居补贴+就业补贴，来象就业享“真金白银”人才礼包</div>
        <div style="display: flex; align-items: center; justify-content: center;">
          <div class="div_ze" @click.stop="goLink(3)">
            政策速览
            <img src="../assets/images/ic_arrow_right.png" style="width: 16px;height: 10px;"></img>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'RecruitCalendar',
  props: {
    dataObject: {
      type: Object,
      required: true
    }
  },
  watch: {
    dataObject: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.$nextTick(() => {
          })
        }
      },
      deep: true,
      immediate: true
    },
  },
  data() {
    return {
      year: 2025,
      month: 8, // 0-based, 2=3月
      weekDays: ['一', '二', '三', '四', '五', '六', '日'],
      eventData: {},
      monthTitleMap: {
        '2025-03': '象山县2025春季招聘会',
        '2025-02': '象山县2025春季招聘会'
      },
      selectedDate: '', // 添加选中日期
      scrollY: 0,
      eventItemHeight: 26,
      scrollTimer: null,
      visibleCount: 5, // 可视条数
      showMoreMenu: false,
      moreMenuList: [
        {configName: '象山在线招聘网', url: 'https://www.xsmpw.com/'},
        {configName: '宁波人力资源综合服务平台', url: 'https://ycyg.nbhr.org.cn/'}
      ],
      isModalVisible: false,
      popupEvents: [],
      popupTitle: '',
    }
  },
  computed: {},
  mounted() {
  },
  beforeDestroy() {
  },
  created() {
  },
  methods: {
    goLink(type) {
      if (type === 1) {
        window.open('http://www.xsrcds.com/', '_blank');
      } else if (type === 2) {
        window.open('http://www.xsrcds.com/Home/Questionnaire/index', '_blank');
      } else if (type === 3) {
        window.open(require('../assets/images/pdf/高校毕业生引聚政策折页.pdf'), '_blank');
      }
    },
  }
}
</script>

<style scoped>
.recruit-calendar-panel {
  padding-top: 5px;
  background-image: url('../assets/images/home_zhaoping.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  padding-bottom: 15px;
}

.div_ze {
  display: inline-flex;
  width: fit-content;
  max-width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  justify-content: center;
  border-radius: 30px;
  flex-direction: row;
  margin-bottom: 10px;
  align-content: center;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;
  gap: 5px;
  color: #1774FF;
  cursor: pointer;
  border: 1px solid #1774FF;

}

.calendar-content {
  width: 40%;
  min-width: 0;
  height: 100%;
  border-radius: 4px;
  display: flex;
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px;
  flex-direction: column;
  background: url(".././assets/images/ic_right_2.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  isolation: isolate;
}

.qy-num {
  border-radius: 5px;
  margin-top: 5px;
  color: #7F6F33;
  width: fit-content;
  max-width: 100%;
  font-size: 13px;
  display: inline-flex;
  background: #FAFAD8;
  padding: 0 10px;
  flex-direction: row;
  align-items: center;
}

.div_send_btn {
  cursor: pointer;
  background: url("../assets/images/ic_img_btn.png") no-repeat;
  background-size: cover;
  width: 120px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  line-height: 36px;
  text-align: center;
  justify-items: center;
  color: #FFFFFF;
}

.calendar-title {
  font-size: 16px;
  font-weight: bold;
  display: flex;
  height: 40px;
  align-items: center;
  background-image: url('../assets/images/icon_home_right.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  gap: 8px;
  font-family: PingFang SC, PingFang SC;
  color: #FFFFFF;
  text-align: right;
  font-style: normal;
  text-transform: none;
  justify-content: space-between;
  position: relative;
}

.calendar-title-left {
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-family: PingFang SC, PingFang SC;
  font-size: 20px;
  color: white;
  text-align: left;
  font-style: normal;
  text-transform: none;
  font-weight: bold;
}

.qy-text {
  opacity: 1;
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 15px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #1774FF;
}

.des_span {
  opacity: 1;
  font-family: Alibaba PuHuiTi 2.0;
  font-size: 12px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;
  flex: 1;
  padding-top: 10px;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #505050;
}

.calendar-main {
  display: flex;
  height: 275px;
  padding: 10px;
  flex-direction: row;
  position: relative;
  min-width: 0;
  overflow: hidden;
  align-items: stretch;
}

.calendar-left {
  width: 30%;
  min-width: 0;
  height: 100%;
  border-radius: 4px;
  opacity: 1;
  display: flex;
  padding: 10px;
  flex-direction: column;
  background: url(".././assets/images/ic_right_1.png") no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
}


.calendar-right {
  width: 30%;
  min-width: 0;
  height: 100%;
  border-radius: 4px;
  opacity: 1;
  display: flex;
  padding: 10px;
  flex-direction: column;
  background: url(".././assets/images/ic_right_3.png") no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
}


</style>
